import { render, staticRenderFns } from "./ViewResellerPaymentComponent.vue?vue&type=template&id=6bffa7d3"
import script from "./ViewResellerPaymentComponent.vue?vue&type=script&lang=js"
export * from "./ViewResellerPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports